export default __webpack_public_path__ + "static/media/FindThePerfectGift.30ecb931.svg";